<template>
  <section v-if="sponsors.length" :class="$style['sponsors']" aria-labelledby="sponsors-title">
    <h2 id="sponsors-title" :class="$style['sponsors__title']">Met steun van</h2>
    <div :class="$style['sponsors__window']">
      <ul :class="$style['sponsors__track']">
        <template v-for="copy in 2" :key="copy">
          <li v-for="sponsor in sponsors" :key="`${copy}-${sponsor.uuid}`" :aria-hidden="copy === 2 || undefined">
            <component
              :is="sponsor.content.link?.cached_url ? 'a' : 'span'"
              :href="sponsor.content.link?.cached_url || undefined"
              :target="sponsor.content.link?.cached_url ? '_blank' : undefined"
              :rel="sponsor.content.link?.cached_url ? 'noopener' : undefined"
              :tabindex="copy === 2 ? -1 : undefined"
              :class="$style['sponsors__item']">
              <NuxtImg
                v-if="sponsor.content.image?.filename"
                :src="sponsor.content.image.filename"
                :alt="copy === 2 ? '' : sponsor.content.name"
                height="112"
                format="webp"
                loading="lazy" />
              <span v-else :class="$style['sponsors__name']">{{ sponsor.content.name }}</span>
            </component>
          </li>
        </template>
      </ul>
    </div>
    <p v-if="route.path !== '/sponsoring'" :class="$style['sponsors__more']"><NuxtLink to="/sponsoring">Sponsor worden</NuxtLink></p>
  </section>
</template>
<script setup lang="ts">
// The sponsor logos (white on transparent) glide past; hovering pauses them
const route = useRoute()
const data = await useHrStoryblok('cdn/stories', { version: 'published', content_type: 'Sponsor' })
const sponsors = computed(() => ((data as any)?.stories ?? []).slice().sort((a: any, b: any) => a.name.localeCompare(b.name)))
</script>
<style module>
.sponsors {
  padding-block: var(--stage-section) calc(var(--stage-section) * 0.8);
  overflow: hidden;
  background: var(--stage-black);
  color: var(--stage-white);
}

.sponsors__title {
  margin: 0 0 var(--spacing-xxxl);
  font-family: var(--font-family);
  font-weight: var(--font-weight-normal);
  font-size: var(--font-size-base);
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: var(--stage-soft);
}

.sponsors__track {
  display: flex;
  align-items: center;
  gap: clamp(3rem, 6vw, 6rem);
  width: max-content;
  margin: 0;
  padding: 0;
  list-style: none;
  animation: sponsors-run 50s linear infinite;
}

.sponsors__window:hover .sponsors__track {
  animation-play-state: paused;
}

@keyframes sponsors-run {
  to { transform: translateX(-50%); }
}

.sponsors__item {
  display: grid;
  place-items: center;
  height: 5.5rem;
}

.sponsors__item img {
  width: auto;
  max-width: 13rem;
  height: auto;
  max-height: 3.5rem;
  opacity: 0.85;
  transition: opacity 200ms;
}

.sponsors__item:hover img {
  opacity: 1;
}

.sponsors__name {
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-large);
  text-transform: uppercase;
}

.sponsors__more {
  margin: var(--spacing-xxl) 0 0;
  text-align: center;
  font-size: var(--font-size-small);
}

.sponsors__more a {
  color: var(--stage-soft);
  text-underline-offset: 0.3em;
}

@media (prefers-reduced-motion: reduce) {
  .sponsors__window {
    overflow-x: auto;
  }

  .sponsors__track {
    animation: none;
  }
}
</style>
